import React, { useEffect } from 'react'

import { SecondaryNavLayout } from 'src/modules/ui'

import { useMessages } from '../hooks'
import Conversations from './Conversations'
import SingleConversation from './SingleConversation'

const Messages = () => {
  const { fetchUnreadConversationsCount } = useMessages()
  useEffect(() => {
    fetchUnreadConversationsCount()
  }, [])

  const routes = [
    {
      navLabel: 'Inbox',
      path: '/messages/inbox',
      render: props => <Conversations {...props} section="inbox" />,
    },
    {
      navLabel: 'Sent',
      path: '/messages/sent',
      render: props => <Conversations {...props} section="sent" />,
    },
    {
      path: '/messages/:id/',
      component: SingleConversation,
      title: 'Conversation',
    },
  ]

  return <SecondaryNavLayout routes={routes} />
}
export default Messages
